import React from 'react'
import { Button, Form, Input, Select} from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx



const InterfaceInput = ({ title }) => {
  const { InterfaceStore } = useStore()

  // 取消按钮
  const [form] = Form.useForm()

  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      await InterfaceStore.getAddButtom(values)
    } else if (title === '编辑') {
      console.log(values,'bj')
      await InterfaceStore.getPutInformation(values)
    }
    runInAction(() => {
      set(InterfaceStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{
            
          }}
        >
           <Form.Item label="所属系统" name='jrxtid'
          rules={[
            {
              required: true,
              message: '所属系统',
            }
          ]}>
          <Select placeholder="请选择" options={toJS(InterfaceStore.selectList)}>
          </Select>
        </Form.Item>
          <Form.Item label="备注" name="remarks" rules={[
            {
              required: true,
              message: '请输入备注',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(InterfaceStore.valueData)}
        >
          <Form.Item label="备注" name="remarks" rules={[
            {
              required: true,
              message: '请输入备注',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
       {
        title === '查看' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(InterfaceStore.valueData)}
        >
          <Form.Item label="所属系统" >
            {InterfaceStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="AppId">
           {InterfaceStore.valueData.appid}
          </Form.Item>
          <Form.Item label="SecretKey">
             {InterfaceStore.valueData.secretKey}
          </Form.Item>
          <Form.Item label="AesKey">
             {InterfaceStore.valueData.aesKey}
          </Form.Item>
          <Form.Item label="次数">
             {InterfaceStore.valueData.account}
          </Form.Item>
          <Form.Item label="备注">
            {InterfaceStore.valueData.remarks}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(InterfaceInput)